import { Badge, Button } from "@radix-ui/themes";
import { useAppDispatch } from "../../store";
import { togglePaymentModal } from "../../store/slices/modalsSlice";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export function AppBasedPayment(_: { isCompleted: boolean }) {
  const [searchParams] = useSearchParams();
  const enableMobilePayment = JSON.parse(
    searchParams.get("enable_mobile_payment") || "false"
  );

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col relative">
      {!enableMobilePayment && (
        <Badge
          className="!bg-red-100 border border-red-200 absolute z-[1] top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 -rotate-[20deg]"
          color="red"
        >
          Coming Soon
        </Badge>
      )}
      <Button
        size="4"
        className="grow w-full"
        variant="classic"
        disabled={!enableMobilePayment}
        onClick={() => {
          dispatch(
            togglePaymentModal({
              open: true,
            })
          );
        }}
      >
        {t("appBasedPayment")}
      </Button>
    </div>
  );
}
